<template>
  <div>
    <div class="edit-form-title">
      <h1>Pricing Packages</h1>
      <div class="package-header-note">
        Each sponsorship partner might only be interested in a handful of items you can offer.
        You are more likely to create meaningful partnerships by offering a la carte sponsorship
        items versus bundling items into packages. Make a sincere interest in the goals
        of your sponsor and help them achieve their goals. For each item, include what is
        being offered to the sponsor and at least one end-of-event deliverable.
      </div>
      <div class="edit-form">
        <button aria-label="Add Pricing" class="add-link-button"
          @click="editingPackage = 'new'">
          + Add a Pricing Package
        </button>
      </div>
    </div>
    <portal to="dialogs" v-if="editingPackage">
      <event-pricing-package-editable
        :eventId="eventId"
        :allOfferings="allOfferings"
        :pricingPackage="editingPackage"
        @save="onSavePackage"
        @cancel="editingPackage = null"
      ></event-pricing-package-editable>
    </portal>
    <div class="edit-form pricing-wrapper">
      <event-pricing-package
        class="package"
        v-for="(pricingPackage, i) in pricingPackages" :key="i"
        :id="pricingPackage.id"
        :title="pricingPackage.title"
        :amount="pricingPackage.amount"
        :maxAmount="pricingPackage.maxAmount"
        :negotiable="pricingPackage.negotiable"
        :quantity="pricingPackage.quantity"
        :deadline="pricingPackage.deadline"
        :offerings="pricingPackage.offerings"
        :deliverables="pricingPackage.deliverables"
        :description="pricingPackage.description"
        :eventId="eventId"
        @change="onSavePackage"
        @edit="editingPackage = pricingPackage"
        :canEdit="true"
        >
        </event-pricing-package>
    </div>
    <div class="edit-form">
      <button class="button" aria-label="Next" @click="goNext">
        Next
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EventPricingPackage from '@/components/event/view/EventPricingPackage.vue';
import EventPricingPackageEditable from '@/components/event/edit/EventPricingPackageEditable.vue';

export default {
  name: 'event-pricing',
  components: {
    EventPricingPackage,
    EventPricingPackageEditable,
  },
  data() {
    return {
      eventId: null,
      pricingPackages: [],
      allOfferings: [],
      editingPackage: null,
    };
  },
  async mounted() {
    this.eventId = this.$route.params.eventId;
    try {
      const allOfferingsResponse =
        await this.backendAxios.get('/sponsorship-event/event-offerings');
      this.allOfferings = allOfferingsResponse.data;
      await this.fetchPricingPackages();
    } catch (err) {
      this.$toasted.show(err.response.data, {
        type: 'info',
        duration: 5000,
      });
    }
  },
  computed: {
    ...mapState('auth', ['backendAxios']),
  },
  methods: {
    addPricingPackage(data = {}) {
      const pricingPackage = {};
      pricingPackage.id = data._id;
      pricingPackage.title = data.title;
      pricingPackage.amount = data.amount;
      pricingPackage.maxAmount = data.maxAmount;
      pricingPackage.description = data.description;
      pricingPackage.quantity = data.quantity;
      pricingPackage.negotiable = data.negotiable;
      pricingPackage.deadline = data.deadline || this.endDate;
      pricingPackage.deliverables = data.deliverables || [''];
      pricingPackage.offerings = data.offerings || [];
      this.pricingPackages.push(pricingPackage);
    },
    async fetchPricingPackages() {
      try {
        this.pricingPackages = [];
        const eventResponse = await this.backendAxios
          .get(`/sponsorship-event/my-event/id/${this.eventId}?fields=pricingPackages,endDate`);
        const { pricingPackages } = eventResponse.data;
        this.endDate = eventResponse.data.endDate;
        pricingPackages.forEach(pricingPackage => this.addPricingPackage(pricingPackage));
      } catch (err) {
        this.$toasted.show(err.response.data, {
          type: 'info',
          duration: 5000,
        });
      }
    },
    async goNext() {
      this.$router.push(`/event/${this.eventId}/edit/market`);
    },
    async onSavePackage() {
      this.editingPackage = null;
      this.fetchPricingPackages();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.pricing-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
}

.package {
  max-width: 18rem;
  margin: 0.5rem;
}

</style>
